import ApiService from "./api";
import store from "@/store";

const Product = {
    show(identifier, params) {
        return ApiService.get('product/'+identifier, {params: params});
    },
    getAssets(identifier, params = null) {
        return ApiService.get('machine/'+identifier+'/assets', {params: params});
    },
    getAttachments(identifier, params = null) {
        return ApiService.get('machine/'+identifier+'/accessories', {params: params});
    },
    getHandover(identifier, params = null) {
        return ApiService.get('machine/'+identifier+'/handover', {params: params});
    },
    getCompendium(identifier, params = null) {
        return ApiService.get('machine/'+identifier+'/compendium', {params: params});
    },
    list(postDatas, params) {
        const country = store.state.settings.country;
        let finalParams = params;
        if(country && params.country === undefined)
            finalParams = {...params, country: country};
        return ApiService.post('products', postDatas, {params: finalParams});
    },
    categories(params) {
        const country = store.state.settings.country;
        let finalParams = params;
        if(country && params.country === undefined)
            finalParams = {...params, country: country};
      return ApiService.get('machine/categories', {params: finalParams});
    },
    filters(productType, category, subcategory, params) {
      return ApiService.get(productType+'/'+category+'/filters'+(subcategory ? '/'+subcategory : ''), {params: params});
    },
    applications(params) {
        return ApiService.get('applications', {params: params});
    },
    machineAccessories(identifier, params) {
        return ApiService.get('machine/'+identifier+'/accessories', {params: params});
    },
    machineOptions(identifier, params) {
        return ApiService.get('options/'+identifier, {params: params});
    },
    keyFeatures(params) {
        return ApiService.get("category-key-features", {params: params});
    },
    services(params) {
        const country = store.state.settings.country;
        let finalParams = params;
        if(country && params.country === undefined)
            finalParams = {...params, country: country};
        return ApiService.get("services", {params: params});
    },
    accessoryMachines(identifier, params) {
        return ApiService.get('attachments/'+identifier+'/machines', {params: params});
    },
};

export default Product;
